import React, { useState } from "react";
import { Bell, BellRing, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { createNotification } from "@/lib/api";
import { useAuth, startGoogleLogin } from "@/lib/auth";
import { useLocale } from "@/lib/locale";

export default function NotifyMeButton({ title, alreadyTurkishDub }) {
  const { user } = useAuth() || {};
  const { t } = useLocale();
  const [armed, setArmed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!user) {
      toast(t("sign_in_to_post"));
      startGoogleLogin();
      return;
    }
    setLoading(true);
    try {
      await createNotification(title.id, "tr");
      setArmed(true);
      toast.success(`${t("alert_armed")}: ${title.title}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  if (alreadyTurkishDub) {
    return (
      <div
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 font-heading text-sm"
        data-testid="notify-already-available"
      >
        <Check className="h-4 w-4" /> {t("already_tr_dub")}
      </div>
    );
  }

  return (
    <Button
      onClick={handleClick}
      disabled={loading || armed}
      className={`font-heading rounded-md px-5 py-2.5 ${
        armed
          ? "bg-emerald-500/15 border border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/20"
          : "bg-amber hover:bg-amber-hover text-obsidian shadow-[0_10px_40px_-12px_rgba(245,166,35,0.6)]"
      }`}
      data-testid="notify-me-btn"
    >
      {armed ? <BellRing className="h-4 w-4 mr-2" /> : <Bell className="h-4 w-4 mr-2" />}
      {armed ? t("alert_armed") : t("notify_tr_dub")}
    </Button>
  );
}
